import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  padding: 0;
  
  &.open {
    z-index: 100;
    opacity: 1;
  }

  &.closed {
    width: 0;
    opacity: 0;
    pointer-events: none; 
    touch-action: none;
  }
`
export const Container =  styled.div`
  width: 100%;
  max-height: 100vh;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  padding: 0;

  &.open {
    transform: translateX(0);
    opacity: 1;
    display: flex;
    transition: all .2s linear;
    z-index: 99;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none !important;
    }
  }

  &.closed {
    width: 0;
    transform: translateX(-480px);
    opacity: 0;
    pointer-events: none; 
    touch-action: none;
    transition: all .2s linear;
  }
`

export const StyledClose = styled.div`
  position: absolute;
  top: 20px;
  left: 80vw;
  z-index: 100 !important;
  svg {
    width: 2em;
    height: 2em;

    path {
      stroke: #fff;
      stroke-width: 0.78;
    }
  }

  @media (min-width: 768px) {
    display: none;
  }
`

export const MenuContent =  styled.div`
  width: 100%;
  position: relative;
  background: #FFF;
  
  @media (min-width: 768px) {
    background: #fff;
    width: 75%;
  }
`

export const MenuContainer = styled.div`
  position: relative;
  width: 100%;
  background: #FFF;
  transform: translateX(0);
  opacity: 1;
  transition: all .5s ease-out;

  @media (min-width: 768px) {
    width: 25%;
    min-width: 350px;
  }
`

export const StyledMap = styled.div`
  display: grid;
  height: 100vh;
  grid-template-rows: 50px calc(100vh - 334px) 284px;
`;

export const StyledIcon = styled.div`
  grid-row: 1;
  padding-left: 15px;
  padding-top: 10px;
  svg {
    path {
      stroke-width: 0.78;
    }
  }
`;

export const StyledMain = styled.div`
  grid-row: 2;
`;

export const StyledFooter = styled.div`
  grid-row: 3;
  align-self: end;
`;
